import { HttpClient } from '@angular/common/http';
import {
    EntityActionFactory,
    EntityCacheDispatcher,
    EntityOp,
    HttpUrlGenerator,
    Logger, MergeStrategy,
    QueryParams
} from '@ngrx/data';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';
import { WebsocketBrokerService } from '../../../../core/services/websocket-broker.service';
import { WebSocketEntityDataServiceBase } from '../../../../state/entity/web-socket-entity-data-service-base';
import { missedAppointmentsDashboardEntityMetadata } from './missed-appointments-dashboard.entity';

export const entityActionFactory = new EntityActionFactory();

export abstract class MissedAppointmentsDashboardEntityDataServiceBase<T> extends WebSocketEntityDataServiceBase<any> {
    subscriptions: Subscription = new Subscription();

    constructor(http: HttpClient,
                httpUrlGenerator: HttpUrlGenerator,
                logger: Logger,
                public entityCacheDispatcher: EntityCacheDispatcher,
                public websocketBrokerService: WebsocketBrokerService,
                entityName: string,
                public webSocketTopic: string) {
        super(entityName, http, httpUrlGenerator);
    }

    getWithQuery(parameters: string | QueryParams): Observable<Array<any>> {
        return super.getWithQuery(parameters);
    }

    subscribeWebSocketJobWithBody(initialBody: any): void {
        // NOTE: Since we're not subscribing to the result inside an NgRx Effect we need to subscribe here and manage the
        //       subscription.
        const websocketBrokerServiceSubscription =
            this.websocketBrokerService.getRemoteObservable(this.webSocketTopic, initialBody)
                .pipe(
                    map((pushedPayload: any) => {
                        if (pushedPayload.error === undefined) {
                            const data: any = [];
                            let totalMissedCount = 0;
                            if (pushedPayload.jobs !== undefined) {
                                pushedPayload.jobs.forEach(job => {
                                    data.push(job);
                                    totalMissedCount += job.inProgressEscalatingTotal;
                                });
                            }
                            data.totalMissedCount = totalMissedCount;
                            data.queryFilter = pushedPayload.queryFilter; // Must be added as property to the array object
                            const entityAction = entityActionFactory.create<Array<any>>(
                                missedAppointmentsDashboardEntityMetadata.entityName,
                                EntityOp.QUERY_MANY_SUCCESS,
                                data,
                                {
                                    tag: 'MissedAppointmentsDashboard',
                                    mergeStrategy: MergeStrategy.OverwriteChanges
                                }
                            );
                            this.entityCacheDispatcher.dispatch(entityAction);
                        }
                    })
                )
                .subscribe();
        this.subscriptions.add(websocketBrokerServiceSubscription);
    }

    unsubscribeWebSocketJob(): void {
        this.websocketBrokerService.unsubscribe(this.webSocketTopic);
        this.subscriptions.unsubscribe();
        this.subscriptions = new Subscription();
    }

    refreshWebSocketJobWithBody(messageBody: any): void {
        this.websocketBrokerService.sendAction('refresh', this.webSocketTopic, messageBody);
    }
}
